module.exports = __webpack_public_path__ + "img/loveInvitationText1.0922ef9a.jpg";